<h1 id="title" class="title">Reset password</h1>
<p class="sub-title">Enter your reset code and set a new password</p>

<nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
  <p class="alert-title"><b>Oh snap!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
  </ul>
</nb-alert>

<nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
  <p class="alert-title"><b>Hooray!</b></p>
  <ul class="alert-message-list">
    <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
  </ul>
</nb-alert>

<form (ngSubmit)="resetPass()" #resetPassForm="ngForm" aria-labelledby="title">

  <div class="form-control-group">
    <label class="label" for="input-email">Email:</label>
    <input nbInput
           [(ngModel)]="user.email"
           #email="ngModel"
           id="input-email"
           name="email"
           class="first"
           placeholder="Email address"
           autofocus
           fullWidth
           fieldSize="large"
           [disabled]="true"
           [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="true"
           pattern=".+@.+\..+"
           [attr.aria-invalid]="email.invalid && email.touched ? true : null">
    <ng-container *ngIf="email.invalid && email.touched">
      <p class="caption status-danger" *ngIf="email.errors?.required">
        Email is required!
      </p>
      <p class="caption status-danger" *ngIf="email.errors?.pattern">
        Enter a valid email address.
      </p>
    </ng-container>
  </div>

  <div class="form-control-group">
    <label class="label" for="input-reset-code">Reset Code:</label>
    <input nbInput
           [(ngModel)]="user.resetCode"
           #resetCode="ngModel"
           id="input-reset-code"
           name="resetCode"
           class="first"
           placeholder="Reset code"
           fullWidth
           fieldSize="large"
           [status]="resetCode.dirty ? (resetCode.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="true"
           [attr.aria-invalid]="resetCode.invalid && resetCode.touched ? true : null">
    <ng-container *ngIf="resetCode.invalid && resetCode.touched">
      <p class="caption status-danger" *ngIf="resetCode.errors?.required">
        Reset code is required!
      </p>
    </ng-container>
  </div>

  <div class="form-group">
    <label class="label" for="input-password">New Password:</label>
    <input nbInput
           [(ngModel)]="user.newPassword"
           #newPassword="ngModel"
           type="password"
           id="input-password"
           name="newPassword"
           class="first"
           placeholder="New Password"
           fullWidth
           fieldSize="large"
           [status]="newPassword.dirty ? (newPassword.invalid  ? 'danger' : 'success') : 'basic'"
           [required]="getConfigValue('forms.validation.password.required')"
           [minlength]="getConfigValue('forms.validation.password.minLength')"
           [maxlength]="getConfigValue('forms.validation.password.maxLength')"
           [attr.aria-invalid]="newPassword.invalid && newPassword.touched ? true : null">
    <ng-container *ngIf="newPassword.invalid && newPassword.touched">
      <p class="caption status-danger" *ngIf="newPassword.errors?.required">
        Password is required!
      </p>
      <p class="caption status-danger" *ngIf="newPassword.errors?.minlength || newPassword.errors?.maxlength">
        Password should contain
        from {{ getConfigValue('forms.validation.password.minLength') }}
        to {{ getConfigValue('forms.validation.password.maxLength') }}
        characters
      </p>
    </ng-container>
  </div>

  <div class="form-group">
    <label class="label" for="input-re-password">Confirm New Password:</label>
    <input nbInput
           [(ngModel)]="user.confirmPassword"
           #rePass="ngModel"
           id="input-re-password"
           name="rePass"
           type="password"
           class="last"
           placeholder="Confirm Password"
           fullWidth
           fieldSize="large"
           [status]="rePass.touched
               ? (rePass.invalid || newPassword.value != rePass.value ? 'danger' : 'success')
               : 'basic'"
           [required]="getConfigValue('forms.validation.password.required')"
           [attr.aria-invalid]="rePass.invalid && rePass.touched ? true : null">
    <ng-container *ngIf="rePass.touched">
      <p class="caption status-danger" *ngIf="rePass.invalid && rePass.errors?.required">
        Password confirmation is required!
      </p>
      <p class="caption status-danger" *ngIf="newPassword.value != rePass.value && !rePass.errors?.required">
        Password does not match the confirm password.
      </p>
    </ng-container>
  </div>

  <button nbButton
          status="primary"
          fullWidth
          size="large"
          [disabled]="submitted || !resetPassForm.valid"
          [class.btn-pulse]="submitted">
    Reset password
  </button>
</form>
<!-- 
<section class="sign-in-or-up" aria-label="Sign in or sign up">
  <p><a class="text-link" routerLink="../login">Back to Log In</a></p>
  <p><a class="text-link" routerLink="../register">Register</a></p>
</section> -->
